import { Pipe, PipeTransform } from '@angular/core';
import { ListItem } from 'src/app/models/list-item';

@Pipe({
    name: 'avmFormNullableListValue',
    standalone: true,
})
export class AvmFormNullableListValue implements PipeTransform {
    constructor() {}

    /**
     * Formate une valeur d'un formulaire pour afficher un tiret lorsque la valeur est vide ou nulle.
     * @param value : Valeur à formatter.
     * @param displayFormat : Format à appliquer.
     */
    transform(itemKey: string, listItems: ListItem[]): string {
        if (itemKey && listItems) {
            const item = listItems.find((x) => x.value === itemKey);
            return item.text;
        } else {
            return '-';
        }
    }
}
